import { utils } from '../../devUtils';

const today = utils.momentInstance();
const startDate = utils.momentInstance().subtract(30, 'days');
const startDate2 = utils.momentInstance().subtract(90, 'days');

const INFO_MESSAGES = Object.freeze({
  DOWNLOAD_INFO: 'Please Click on Download Button to Download the PDF Statement',
  PASSWORD_INFO: 'The statement is secured by a Unique Password which is the combination of the First Four Characters of your First Name followed by Last Four Digits of your Mobile Number',
  PASSWORD_EXAMPLE: 'If your First Name is Rohit and Last Name is Kumar and Mobile Number is 1234562376 your Password will be ROHI2376.',
});

export { today, startDate, startDate2, INFO_MESSAGES };



// WEBPACK FOOTER //
// client/containers/NsdlRequestStatement/constants.js